module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_7042.6933fad2.png";